import { createIdSlice } from '../utils/action/createElementSlice';
export const ElementDecoratorState = createIdSlice({
    elementName: 'elementDecorator',
    initialState: {},
    reducers: {
        set(_state, action) {
            return action.payload.data;
        },
        setToolbarItems(state, action) {
            return Object.assign(Object.assign({}, state), { toolbarItems: action.payload.data });
        },
        setAlwaysShowOverflow(state, action) {
            return Object.assign(Object.assign({}, state), { alwaysShowOverflow: action.payload.data });
        },
        notifyToolbarOpen(state) {
            return state;
        },
    },
});
